import styled from "styled-components";
import { Select } from "antd";

export const Container = styled.div`
    width: 97%;
    height: calc(100vh - 101px);
    overflow: hidden;
    
    position: absolute;
    top: 85px;
    z-index: 10;
    background-color: #fff;
    margin-left: 27px;
    border-radius: 8px;
    padding: 24px;

    display: flex;
    flex-direction: column;
    min-height: 0;

    .ant-form-item {
        display: flex;
        flex-direction: column;
        

        .ant-form-item-label {
            text-align: left;
        }
    }

`;

export const HeaderFilters = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
`;

export const Header = styled.div`
  /* background: white; */
  /* padding: 20px 30px; */
  /* border-bottom: 1px solid #e0e0e0; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); */
  position: relative;

    .ant-form-item-required::before {
      content: none !important;
    }

  .ant-form-item-required::after {
    display: inline-block !important;
    margin-left: 4px !important;
    color: red;
    font-size: 14px !important;
    line-height: 1 !important;
    content: "*" !important;
  }
`;

export const CalendarNav = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  transform: translate(0, 3px);
  z-index: 2;
`;

export const Button = styled.button`
  padding: 7px 10px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  gap: 6px;
  height: 40px;

  &.button-icon {
    padding-left: 5px;
    padding-right: 5px;
  }

  &:disabled {
    background: #ddd !important;
    cursor: not-allowed !important;
    opacity: 0.5;

    &:hover {
      background: #ddd !important;
      box-shadow: none !important;
      color: #666;
    }
  }

  > svg {
      font-size: 20px;
  }
`;

export const ButtonToday = styled(Button)`
  border-color: #e0e0e0;
  color: #666;

  &:hover {
    background: #1976d2;
    color: white;
    box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);
  }

  &:disabled {
    background: #ddd !important;
    cursor: not-allowed !important;
    opacity: 0.5;

    &:hover {
      background: #ddd !important;
      box-shadow: none !important;
      color: #666;
    }
  }
`;

export const CalendarTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  cursor: pointer;
  position: relative;
  z-index: 10;
`;

export const RangeCalendarDropdown = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 50;

  background: #ffffff;
  border: 1px solid #eaeaea;
  border-radius: 8px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
  padding: 12px;

  width: 340px;
`;

export const ViewDropdown = styled.div`
  position: relative;
  display: inline-block;
  width: 115px;
  
  .ant-select-selector {
    height: 45px !important;
    padding: 8px 11px !important;
    
    border: 1px solid #e0e0e0 !important;
    
    .ant-select-selection-placeholder {
      color: #666 !important;
    }
  }
`;

export const ViewDropdownButton = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: 1px solid #ddd;
  background: white;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  transition: all 0.3s;
  min-width: 130px;
`;

export const AgendaTypeSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
  /* border-right: 1px solid #e0e0e0; */
`;
export const AgendaTypeButton = styled.button<{ active?: boolean }>`
  padding: 4px;
  height: 40px;
  border: 2px solid #e0e0e0;
  background: white;
  border-radius: 8px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  color: #666;
  transition: all 0.3s;

  ${props => !props.active && `
    &:hover {
      border-color: #2196f3;
      background: #f0f8ff;
      color: #2196f3;
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(33, 150, 243, 0.2);
    }
  `}

  ${props => props.active && `
    background: #12619C;
    color: white;
    border-color: #1976d2;
    box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);
  `}

  &:disabled {
    background: #ddd !important;
    cursor: not-allowed !important;
    color: #666;
    opacity: 0.5;
    border: none;

    &:hover {
      background: #ddd !important;
      box-shadow: none !important;
      color: #666;
    }
  }
`;

export const AgendaTypeButtonExport = styled(AgendaTypeButton)`
  background-color: #009157;
  color: #fff;

  &:hover {
    background-color: #009157;
    color: #fff;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
`

export const RowField = styled.div`
  display: flex;
  flex-direction: column;

  flex: 1;
  min-height: 0;
  /* overflow-y: auto; */
`;

export const Content = styled.div`
    flex: 1;
    min-height: 0;

    display: flex;
    flex-direction: column;
`;

export const SelectAntd = styled(Select)`
  width: 100% !important;

  .ant-select-selector {
    height: 40px !important;
    border-radius: 8px !important;
    padding: 4px 11px !important;
  }
`;

export const ContainerButtons = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
`;

export const ButtonIcon = styled.button`
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: none;
    background: #1976d2;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    padding: 0;
    color: #fff;

    svg {
        font-size: 14px;
    }

    :disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

export const ButtonIconView = styled(ButtonIcon)`
    background: #1976d2;
`;

export const ButtonIconEdit = styled(ButtonIcon)`
    background: #757575;
`;

export const ButtonIconApprove = styled(ButtonIcon)`
    background: #4caf50;
`;

export const ModalContainer = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;

  flex: 1;
  min-height: 0;
  height: 100%;
`;

export const ContentLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;